import { GET_RFR_NOTICES } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface RfrNoticesState extends BaseAsyncReducerState {
    success: boolean;
    response: null | Record<string, unknown>;
    roll: null | string;
}

// Define an initial state value for the app
const initialState: RfrNoticesState = {
    loading: false,
    error: false,
    success: false,
    roll: null,
    response: null
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function rfrNoticesReducer(state = initialState, action: AppAction): RfrNoticesState | Record<string, unknown> {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case GET_RFR_NOTICES.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
            }
        case GET_RFR_NOTICES.SUCCESS:
            return {
                ...state,
                ...payload,
                response: {...payload},
                loading: false,
                error: false,
                success: true,
            }
        case GET_RFR_NOTICES.ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
                success: false,
            }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default rfrNoticesReducer;